import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { PaginationComponent } from "./pagination.component";

type PaginationProps = {
    currentNumberOfHits: number;
    totalNumberOfHits: number;
    hitsPerPage: number;
    loading?: boolean;
    onLoadMore: () => void;
    className?: string;
};

const Pagination = ({
    currentNumberOfHits,
    totalNumberOfHits,
    hitsPerPage,
    loading,
    onLoadMore,
    className
}: PaginationProps) => {
    const { t } = useGranite();

    const statusText = t(
        "search.pagination.status",
        `<b>${currentNumberOfHits}</b>`,
        `<b>${totalNumberOfHits}</b>`
    );

    const hitsToLoad = Math.min(
        hitsPerPage,
        totalNumberOfHits - currentNumberOfHits
    );

    return (
        <PaginationComponent
            currentNumberOfHits={currentNumberOfHits}
            totalNumberOfHits={totalNumberOfHits}
            statusText={statusText}
            hitsToLoad={hitsToLoad}
            loading={loading ?? false}
            onClick={onLoadMore}
            className={className}
        />
    );
};

export { Pagination };
